"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureTheTalent() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: descRef,
    isVisible: descVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="5190" id="secure-the-talent" className="relative bg-background text-foreground overflow-hidden py-32 md:py-48 lg:py-[200px] px-6">
      {}
      <div aria-hidden="true" className="absolute left-4 md:left-8 top-0 bottom-0 w-px" style={{
      backgroundColor: "var(--border)",
      opacity: 0.6
    }} />
      <div aria-hidden="true" className="absolute right-4 md:right-8 top-0 bottom-0 w-px" style={{
      backgroundColor: "var(--border)",
      opacity: 0.6
    }} />

      {}
      <div aria-hidden="true" className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <svg viewBox="0 0 800 800" className="w-[600px] h-[600px] md:w-[900px] md:h-[900px] lg:w-[1100px] lg:h-[1100px]" style={{
        opacity: 0.05
      }}>
          <g fill="none" stroke="var(--foreground)" strokeWidth="0.5">
            <circle cx="400" cy="400" r="380" />
            <circle cx="400" cy="400" r="320" />
            <circle cx="400" cy="400" r="250" />
            <circle cx="400" cy="400" r="170" />
            <circle cx="400" cy="400" r="90" />
            <ellipse cx="400" cy="400" rx="380" ry="120" />
            <ellipse cx="400" cy="400" rx="380" ry="220" />
            <ellipse cx="400" cy="400" rx="380" ry="320" />
            <ellipse cx="400" cy="400" rx="120" ry="380" />
            <ellipse cx="400" cy="400" rx="220" ry="380" />
            <ellipse cx="400" cy="400" rx="320" ry="380" />
            <line x1="20" y1="400" x2="780" y2="400" />
            <line x1="400" y1="20" x2="400" y2="780" />
          </g>
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto flex flex-col items-center text-center">
        {}
        <h1 ref={headlineRef} className={`font-default font-light uppercase text-[80px] sm:text-[100px] md:text-[120px] lg:text-[144px] transition-all duration-1000 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        lineHeight: "1.0",
        letterSpacing: "-0.02em"
      }}>
          <span className="block">SECURE</span>
          <span className="block">THE</span>
          <span className="block" style={{
          color: "var(--primary)",
          opacity: 0.9
        }}>
            TALENT.
          </span>
        </h1>

        {}
        <p ref={descRef} className={`font-sans font-light text-lg md:text-xl mt-10 md:mt-14 max-w-[540px] transition-all duration-700 delay-200 ${descVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        color: "var(--muted-foreground)",
        lineHeight: "1.6"
      }}>
          Available for cinematic productions and theatrical engagements worldwide.
        </p>

        {}
        <div ref={ctaRef} className={`mt-14 md:mt-20 flex flex-col items-center gap-8 transition-all duration-700 delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="relative">
            <div aria-hidden="true" className="absolute inset-0 -bottom-10 blur-3xl" style={{
            backgroundColor: "var(--primary)",
            opacity: 0.1,
            transform: "translateY(40px)"
          }} />
            <Button asChild className="inline-flex items-center justify-center gap-2 whitespace-nowrap disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs py-2 has-[>svg]:px-3 relative h-[72px] px-10 md:px-14 text-base md:text-lg font-medium uppercase tracking-widest font-sans rounded-md border border-primary bg-transparent hover:bg-primary hover:text-primary-foreground transition-all duration-300 text-primary" style={{
            letterSpacing: "0.2em"
          }}>
              <Link to="/RepresentationPage">
                INQUIRE FOR BOOKING
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>

          {}
          <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.2em] uppercase" style={{
          color: "var(--muted-foreground)"
        }}>
            <span className="relative flex size-2">
              <span className="absolute inline-flex h-full w-full animate-ping opacity-75" style={{
              backgroundColor: "var(--primary)",
              borderRadius: "9999px"
            }} />
              <span className="relative inline-flex size-2" style={{
              backgroundColor: "var(--primary)",
              borderRadius: "9999px"
            }} />
            </span>
            <span>GLOBAL REPRESENTATION</span>
            <span style={{
            color: "var(--border)"
          }}>·</span>
            <span>SAG-AFTRA ELIGIBLE</span>
          </div>
        </div>
      </div>
    </section>;
}